module.exports = __webpack_public_path__ + "static/media/no-result.4453ec40.svg";